/**
 * @file パスポートとは？
 *
 */
'use strict';

/**
 * @classname WhatPassport
 * @classdesc パスポートとは？
 */
export default class WhatPassport {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('WhatPassport.constructor');
		this._$e = $e;
		$(window).on('scroll', () => this.onScroll());
	};

	/**
	 * スクロールのロールバック
	 *
	 * @memberof WhatPassport
	 * @return {undefined}
	 */
    onScroll(){
		console.log('WhatPassport.onScroll');
		const scroll = $(window).scrollTop();
		if(scroll > 390){
            this._$e.addClass('fixed');
        }else{
            this._$e.removeClass('fixed');
        }
	}
}
